import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';

const GuestGuard = ({ children }) => {
  const user = useSelector((state) => state.user);

  if (user.data) {
    return <Redirect to="/billing/plans" />;
  }

  return children;
};

GuestGuard.propTypes = {
  children: PropTypes.any
};

export default GuestGuard;
